// extracted by mini-css-extract-plugin
export default {"goBack":"BackTo_goBack__AMTwM"};